/**
 * 全局过滤器
 * 
 * @param {Object} filters
 * @returns 
 */
const filters = {
    /**
     * statusFilter => 患者状态过滤器
     * 
     * @param {Number} val 状态
     * @returns 
     */
    statusFilter: (val) => {
        if (val == 0) {
            return "未到"
        } else if (val == 1) {
            return "预约"
        } else if (val == 2) {
            return "已到"
        } else if (val == 3) {
            return "消费"
        } else {
            return "添加"
        }
    },
    /**
     * visitreFilter => 跟踪次数
     * 
     * @param {Array} val 跟踪列表
     * @returns 
     */
    visitreFilter: (val) => {
        if (val == null) {
            return 0
        } else {
            return val.length
        }
    },
    /**
     * TimeFilter => 日期截取
     * 
     * @param {String} val 创建日期
     * @returns 
     */
    TimeFilter(val) {
        return val.substring(0, val.lastIndexOf(":"))
    },
    /**
     * channelFilter => 回访渠道(1:电话,2:微信,3:短信,4:其他)
     * 
     * @param {Number} val 状态
     * @returns 
     */
    channelFilter(val) {
        if (val == 1) {
            return "电话"
        } else if (val == 2) {
            return "微信"
        } else if (val == 3) {
            return "短信"
        } else {
            return "其他"
        }
    },
    /**
     * UserFilter => 回访人员
     * 
     * @param {Object} val 状态
     * @returns 
     */
    UserFilter(val) {
        if (val != null) {
            return val.account
        } else {
            return "xxx"
        }
    },
    /**
     * scaleFilter => 预约比例
     * 
     * @param {Object} val 当前值
     * @returns 
     */
    scaleFilter(val) {
        if (val.subscribe == 0) {
            return 0
        } else {
            let scale = val.arrive / val.subscribe
            return scale.toFixed(2) * 100
        }
    },
    /**
     * maleFilter => 男女比例
     * 
     * @param {Object} val 当前值
     * @returns 
     */
    maleFilter(val) {
        if (val.allnum == 0) {
            return "0:0"
        } else {
            let {
                malenum,
                womannum
            } = val
            let gcd = (x, y) => {
                return y == 0 ? x : gcd(y, x % y);
            };
            const divisor = gcd(malenum, womannum);
            const simplifiedA = malenum / divisor;
            const simplifiedB = womannum / divisor;
            return `${simplifiedA}:${simplifiedB}`;
        }
    },
    /**
     * MoneyFilter => 月份截取
     * 
     * @param {Object} val 时间
     * @returns 
     */
    MoneyFilter(val) {
        return val.substring(0, val.lastIndexOf("-"))
    },
    /**
    * SumNumFilter => 统计综合
    * 
    * @param {Array} val 时间
    * @returns 
    */
    SumNumFilter(val) {
        let num = 0;
        val.forEach(item => {
            num += item.num
        })
        return num;
    },
    /**
    * SumNumFilter => 统计综合
    * 
    * @param {Array} val 时间
    * @returns 
    */
    AuthnameFilter(val) {
        if (val != null) {
            return val.authname
        }
        return null;
    },
    /**
   * getDateDescription => 过滤时间
   * 
   * @param {Array} val 时间
   * @returns 
   */
    getDateDescription(val) {
        let dateString = val.resdate + " " + val.restime
        const date = new Date(dateString);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const diff = today - date;
        const diffDays = Math.floor(diff / (1000 * 60 * 60 * 24));
        if (diffDays == 0) {
            return '今天';
        } else if (diffDays == 1) {
            return '昨天';
        } else if (diffDays == 2) {
            return '前天';
        } else {
            return val.resdate;
        }
    },
    /**
     * Filteridentitys => 过滤身份
     * 
     * @param {Array} val 身份
     * @returns 
    */
    Filteridentitys(val) {
        if (val == 0) {
            return "系统"
        } else if (val == 1) {
            return "主管"
        } else if (val == 2) {
            return "组员"
        } else if (val == 3) {
            return "医生"
        } else {
            return "其他"
        }
    },
    /**
    * SectionFilter => 部门权益
    * 
    * @param {Array} val 身份
    * @returns 
   */
    SectionFilter(val) {
        if (val == 0) {
            return "权益：【咨询与服务】双项能力"
        } else if (val == 1) {
            return "权益：【只包括咨询】添加患者"
        } else if (val == 2) {
            return "权益：【只包括服务】跟踪患者"
        } else {
            return "权益：【不参与任何】操作能力"
        }
    },
    /**
    * SectionkeyFilter => 部门权益
    * 
    * @param {Array} val 身份
    * @returns 
   */
    SectionkeyFilter(val) {
        if (val == 0) {
            return "【咨询与服务】"
        } else if (val == 1) {
            return "【只包括咨询】"
        } else if (val == 2) {
            return "【只包括服务】"
        } else {
            return "【不参与任何】"
        }
    },
    /**
     * Filterphonenumber => 手机号后面变星号
     * 
     * @param {Array} val 手机号
     * @returns 
    */
    Filterphonenumber(val) {
        return val.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
}

//导出过滤器
export default {
    filters
}